/******************************************************************************
 * Divider Hook
 * version: 1.0.1, release: 10.06.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

import React, { useState, useEffect, useRef } from 'react';
import PointerControl from '../views/dragview/PointerControl';
import './Divider.scss';


//============================================================================= Divider Hook
export default function Divider(props) {
	const ref = useRef();
	const [direction, setDirection] = useState();

	useEffect(() => {
		if (!ref.current) return

		let [dir, size, trans, move, style] = ref.current.parentNode.classList.contains('hbox')?
			['horizontal', 'clientWidth', 'translateX', 'x', 'width']:
			['vertical', 'clientHeight', 'translateY', 'y', 'height']
		setDirection(dir);

		let target = ref.current.parentNode.children[0]
		let pos = target[size]

		target.style.flexShrink = 0
		target.style.flexGrow = 0
		target.style[style] = pos + 'px'

		ref.current.style.transform = trans + '(' + (pos - 5) + 'px)'

		let pc = new PointerControl(ref.current, {
			onDown: e => {
				pos = target[size]
			},
			onDrag: e => {
				pos += e.move[move]
				ref.current.style.transform = trans + '(' + (pos - 5) + 'px)'
				target.style[style] = pos + 'px'
			}
		})

	}, [])


	return (
		<div
			ref={ref}
			className={'ui2-divider ' + direction}
		/>
	);
}
